export const ru = {
    abortion: 'Услуги по прерыванию беременности',
    'abortion ': 'Услуги по прерыванию беременности',
    'abortion-long-text':
        'Есть противопоказания. Посоветуйтесь с врачом. Возможен вред здоровью.',
    acids: 'Кислоты, газы',
    'ad-image-babyfood':
        'Убедитесь, что графическое объявление соответствует требованиям к рекламе детского питания',
    'ad-image-bad-quality':
        'Убедитесь, что загруженное изображение качественное и чёткое',
    'ad-image-bad-text':
        'Убедитесь, что текст на графическом объявлении можно прочитать',
    'ad-image-distance':
        'Убедитесь, что графическое объявление содержит данные о продавце',
    'ad-image-finance':
        'Убедитесь, что графическое объявление содержит достаточную информацию о предоставителе услуг и источник информации',
    'ad-image-house-cooperative':
        'Убедитесь, что графическое объявление содержит информацию о жилищно-накопительном кооперативе',
    'ad-image-interface-element':
        'Убедитесь, что графическое объявление не содержит элементы пользовательского графического интерфейса',
    'ad-image-lottery':
        'Убедитесь, что графическое объявление содержит необходимую информацию о мероприятии',
    'ad-image-medicine':
        'Убедитесь, что графическое объявление сопровождается необходимым предупреждением',
    'ad-image-nasty': 'Измените изображение графического объявления',
    'ad-image-no-border':
        'Убедитесь, что графическое объявление имеет видимые границы',
    'ad-image-no-source':
        'Убедитесь, что в графическом объявлении указан источник информации',
    'ad-image-share-building': 'Долевое строительство',
    'ad-image-smi':
        'Убедитесь, что графическое объявление содержит категорию информационной продукции',
    alcohol: 'Алкогольная продукция',
    'alcohol-long-text': 'Чрезмерное потребление вредно.',
    'audio-requirements': 'Убедитесь, что аудиоролик соответствует требованиям',
    'baby_food-long-text':
        'Проконсультируйтесь со специалистом. Для питания детей с {text} месяцев',
    banks: 'Банковские услуги',
    'binary-options': 'Бинарные опционы',
    blacklist:
        'Проверьте корректность телефона, указанного в виртуальной визитке',
    bookmaker: 'Букмекерская деятельность',
    'car-numbers': 'Дубликаты государственных номеров',
    charity: 'Благотворительные фонды',
    'contact-info': 'Исключите контактные данные из текста объявления',
    'contact-info-callout': 'Контакты в тексте',
    copyright: 'Предоставьте гарантийное письмо от плательщика',
    'credit-consumer-cooperative': 'Кредитные кооперативы',
    cryptocurrency: 'Криптовалюта',
    detective: 'Детективная деятельность',
    'detective-equipment': 'Отслеживающие устройства',
    'dhref-requirements':
        'Убедитесь, что отображаемая ссылка отвечает требованиям Яндекса',
    dietarysuppl: 'Пищевые добавки',
    'dietarysuppl-long-text': 'Не является лекарством',
    distance_sales: 'Дистанционная продажа',
    drugs: 'Наркотические вещества и рецептурные лекарственные препараты',
    'electronic-osago': 'Электронные полисы ОСАГО',
    errors:
        'Убедитесь, что в тексте нет опечаток, а шаблон используется корректно',
    'errors-callout': 'Опечатки в тексте',
    'errors-ql': 'Убедитесь, что в названиях быстрых ссылок нет опечаток',
    'errors-vcard':
        'Убедитесь, что в подробном описании объекта рекламирования (товара/услуги) в виртуальной визитке нет опечаток',
    explosions: 'Пиротехника',
    'false-info':
        'Исключите из текста объявления слова в превосходной или сравнительной степени',
    'false-info-callout': 'Ложная информация в тексте',
    'false-info-vcard':
        'Исключите из виртуальной визитки слова в превосходной или сравнительной степени',
    'foreign-trade': 'Анализ ТН ВЭД',
    forex: 'Форекс-дилер',
    'forex-broker': 'Форекс-брокер',
    gamble: 'Азартные игры',
    'html5-babyfood': 'Детское питание',
    'html5-bad-quality': 'Плохое качество',
    'html5-bad-text': 'Нечитаемый текст',
    'html5-finance': 'Финансы',
    'html5-funds': 'Фонды',
    'html5-house-cooperative': 'Кооператив',
    'html5-hrefs-errors': 'Убедитесь, что ссылка с баннера задана верно',
    'html5-illness': 'Болезнь',
    'html5-interface-element': 'Элементы интерфейса',
    'html5-lottery': 'Стим.лотерея',
    'html5-medicine': 'Медицина',
    'html5-nasty': 'Неприятное изображение',
    'html5-no-border': 'Нет границ',
    'html5-no-source': 'Нет источника',
    'html5-russian-law': 'По закону России',
    'html5-securities': 'Ценные бумаги',
    'html5-share-building': 'Долевое строительство',
    'html5-smi': 'Защита детей',
    'html5-some-hrefs-not-declared': 'Отсутствуют некоторые ссылки',
    'html5-spam': 'NDA. Пункт 15',
    'illegal-diet': 'БАДы с указанием на лечение',
    insurance: 'Страховые услуги',
    'invalid-contacts':
        'Убедитесь, что контактные данные в виртуальной визитке указаны корректно',
    'invalid-url': 'Проверьте доступность сайта',
    'invalid-url-ql':
        'Проверьте, доступны ли страницы, на которые ведут быстрые ссылки',
    'irrelevant-image':
        'Убедитесь, что изображение соответствует тематике объявления',
    'irrelevant-keywords': 'Добавьте или скорректируйте ключевые фразы',
    'irrelevant-mobile-content':
        'Описание приложения в тексте или теме объявления не соответствует описанию приложения в магазине.',
    'irrelevant-site-link-description':
        'Описание быстрой ссылки не соответствует тексту объявления.',
    jewelry: 'Ювелирные изделия',
    'kazakh-law':
        'Убедитесь, что реклама ваших товаров и услуг разрешена законодательством Республики Казахстан',
    law: 'Юридические услуги, аудит',
    'license-required':
        'Предоставьте подтверждающие документы на рекламируемый товар / услугу',
    'license-required-dhref':
        'Предоставьте подтверждающие документы на рекламируемый товар / услугу',
    'license-required-ql':
        'Предоставьте подтверждающие документы на рекламируемый товар (работу/услугу)',
    'license-required-vcard':
        'Предоставьте подтверждающие документы на рекламируемый товар или услугу',
    loan: 'Займы',
    lottery: 'Лотереи и стимулирующие мероприятия',
    magic: 'Эзотерика и магия',
    'maternity-capital': 'Займы под материнский капитал',
    'med-equipment': 'Медицинские изделия',
    'med-services': 'Медицинские услуги',
    'med_equipment-long-text':
        'Имеются противопоказания. Посоветуйтесь с врачом',
    'med_services-long-text':
        'Имеются противопоказания. Посоветуйтесь с врачом',
    mediation: 'Услуги медиации',
    'medicine-long-text': 'Имеются противопоказания. Посоветуйтесь с врачом',
    mfi: 'Микрофинансовые организации',
    'news-requirements':
        'Убедитесь, что в тексте объявления есть указание на информационный ресурс',
    'not-medicine': 'Книги, видео, сайты о медицине и лечении',
    notary: 'Нотариальные услуги',
    optics: 'Оптика',
    'other-reasons': 'Другие причины',
    pawnshop: 'Ломбарды',
    payment: 'Платежные системы и переводы денежных средств',
    pharmacy: 'Аптеки и лекарства',
    'pharmacy-long-text': 'Имеются противопоказания. Посоветуйтесь с врачом',
    'phone-do-not-answer':
        'Проверьте доступность телефона, указанного в виртуальной визитке',
    politics: 'В Яндекс.Директе не может быть размещена политическая реклама',
    'poor-image': 'Загрузите в интерфейс изображение с большим разрешением',
    'popular-medicine': 'Народная медицина, целительство',
    'project_declaration-long-text':
        'Проектная декларация на рекламируемом сайте',
    pseudoweapon: 'Оружие и изделия, конструктивно сходные с оружием',
    'pseudoweapon-long-text': 'Конструктивно сходные с оружием изделия',
    psychology: 'Психология',
    'ql-requirements':
        'Убедитесь, что страницы, на которые ведут быстрые ссылки, соответствуют требованиям Яндекса',
    realtor: 'Недвижимость',
    'russian-law':
        'Убедитесь, что реклама ваших товаров и услуг допускается действующим законодательством',
    'russian-law-callout':
        'Убедитесь, что реклама ваших товаров и услуг допускается действующим законодательством',
    'russian-law-dhref':
        'Реклама не соответствует действующему законодательству',
    'russian-law-image':
        'Убедитесь, что изображение не противоречит действующему законодательству',
    'russian-law-ql':
        'Убедитесь, что названия быстрых ссылок не противоречат действующему законодательству',
    'russian-law-vcard':
        'Убедитесь, что подробное описание товара (услуги) в виртуальной визитке соответствует действующему законодательству',
    'site-requirements':
        'Убедитесь, что сайт соответствует требованиям Яндекса',
    spam: 'Рекламные материалы не могут быть размещены в Яндекс.Директе',
    'sports-nutrition': 'Спортивное питание',
    study: 'Обучение и работа за рубежом',
    tattoo: 'Татуировки и пирсинг',
    'tech-inspection': 'Технический осмотр',
    telemed: 'Медицинские услуги онлайн',
    tm: 'Предоставьте оригинал гарантийного письма',
    'tm-dhref': 'Предоставьте оригинал гарантийного письма',
    tobacco: 'Сигареты, табак и аксессуары',
    transport: 'Пассажирские перевозки',
    'transport-adv': 'Реклама на транспортных средствах',
    'turbolanding-requirements': 'Требования к турбо-странице',
    'turbolanding-requirements-slink': 'Требования к турбо-странице',
    'url-to-other-domain': 'Проверьте адреса быстрых ссылок',
    veterinary: 'Ветеринарные услуги',
    'video-babyfood':
        'Убедитесь, что видеоролик соответствует требованиям к рекламе детского питания',
    'video-distance-sales':
        'Убедитесь, что видеоролик содержит данные о продавце',
    'video-finance':
        'Убедитесь, что видеоролик содержит достаточную информацию о предоставителе услуг',
    'video-house-cooperative':
        'Убедитесь, что видеоролик содержит информацию о жилищно-накопительном кооперативе',
    'video-lottery':
        'Убедитесь, что видеоролик содержит необходимую информацию о мероприятии',
    'video-medicine':
        'Убедитесь, что видеоролик содержит необходимое предупреждение',
    'video-requirements': 'Убедитесь, что видеоролик соответствует требованиям',
    'video-share-building':
        'Убедитесь, что видеоролик содержит информацию о долевом строительстве',
    'video-smi': 'Убедитесь, что в видеоролике указана возрастная категория',
    weapons: 'Оружие',
    'work-abroad': 'Обучение и работа за рубежом',
    'yandex-policy':
        'Убедитесь, что рекламные материалы соответствуют рекламной политике Яндекса',
    'yandex-policy-auto': 'Реклама товара/услуги запрещена',
    'yandex-policy-callout': 'По политике Яндекса',
    'yandex-policy-image':
        'Убедитесь, что изображение соответствует рекламной политике Яндекса',
    'yandex-policy-vcard':
        'Убедитесь, что подробное описание объекта рекламирования (товара или услуги) в виртуальной визитке соответствует рекламной политике Яндекса'
};
